export function uhrZeit(h: number, m: number) {
    const str = "" + (h * 100 + m + 10000);
    return str.substring(1, 3) + ":" + str.substring(3, 5);
}

export function isoDate(yyyymmdd: string) {
    return yyyymmdd.substring(0, 4) + "-" + yyyymmdd.substring(4, 6) + "-" + yyyymmdd.substring(6, 8);
}

export function jetzt() {
    const ts = new Date();
    const yyyymmdd = isoDate("" + (ts.getFullYear() * 10000 + ts.getMonth() * 100 + ts.getDate() + 100));
    const hhmm = uhrZeit(ts.getHours(), ts.getMinutes());
    return [yyyymmdd, hhmm];
}

export function ultimo(m: number, y: number) {
    if (m === 2) {
        if (y % 4 === 0) {
            return 29;
        }
        return 28;
    }
    if (m === 4 || m === 6 || m === 9 || m === 11) {
        return 30;
    }
    return 31;
}

export function vorTag(yyyymmdd: string) {
    let d = parseInt(yyyymmdd.substring(8, 10));
    let m = parseInt(yyyymmdd.substring(5, 7));
    let y = parseInt(yyyymmdd.substring(0, 4));
    d = d - 1;
    if (d === 0) {
        m = m - 1;
        if (m === 0) {
            m = 12;
            y = y - 1;
        }
        d = ultimo(m, y);
    }
    return isoDate("" + (y * 10000 + m * 100 + d));
}

export function folgeTag(yyyymmdd: string, delta: number) {
    let d = parseInt(yyyymmdd.substring(8, 10));
    let m = parseInt(yyyymmdd.substring(5, 7));
    let y = parseInt(yyyymmdd.substring(0, 4));
    d = d + delta;
    if (d > ultimo(m, y)) {
        d = d - ultimo(m, y);
        m = m + 1;
        if (m === 13) {
            m = 1;
            y = y + 1;
        }
    }
    return isoDate("" + (y * 10000 + m * 100 + d));
}

export function normalesDatum(yyyymmdd: string) {
    return yyyymmdd.substring(8, 10) + "." + yyyymmdd.substring(5, 7) + "." + yyyymmdd.substring(0, 4);
}